import React, { useState } from 'react'

import { Tooltip, Tag } from 'antd'
import { Button } from '@digital/ui'
import { enviarSolicitacaoAprovador } from '@app/api/naoPrevistos/solicitacao'
import { hasPermission } from '@app/helpers/permissions'

export interface IntegracaoAprovadorProps {
    aprovacaoId: string
    appAprovadorId?: string
    appAprovadorDocumentId?: string
    isDaVez?: boolean
    onSuccess: () => void
}

const IntegracaoAprovador = ({ aprovacaoId, appAprovadorId, appAprovadorDocumentId, isDaVez, onSuccess }: IntegracaoAprovadorProps) => {
    const [enviando, setEnviando] = useState(false)

    const handleEnviar = () => {
        setEnviando(true)
        enviarSolicitacaoAprovador(aprovacaoId)
            .then(() => onSuccess())
            .finally(() => setEnviando(false))
    }

    // Integrado de fato com o app aprovador (id retornado pelo aprovador)
    if (appAprovadorId) {
        return (
            <div>
                <Tag color="green">Enviado</Tag>
                <div style={{ fontSize: 12, lineHeight: '18px' }}>
                    <div><b>Documento:</b> {appAprovadorDocumentId}</div>
                    <div><b>ID Aprovador:</b> {appAprovadorId}</div>
                </div>
            </div>
        )
    }

    // Sem integração: só pode enviar se for a vez desta aprovação na sequência
    if (isDaVez) {
        return (
            <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <Tag color="red">Não enviado</Tag>
                {hasPermission(['NAO_PREVISTO_ADMINISTRADOR']) &&
                    <Tooltip title="Enviar ao aprovador">
                        <Button
                            onClick={handleEnviar}
                            icon="messaging-send"
                            loading={enviando}
                            disabled={enviando}
                            confirm="Deseja enviar esta solicitação ao aprovador?"
                            okText="Sim"
                            cancelText="Não"
                        />
                    </Tooltip>
                }
            </span>
        )
    }

    return null
}

export default IntegracaoAprovador
